import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13b02708"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "readonly"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "form-relation-select-dropdown-spin" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_v_nodes = _resolveComponent("v-nodes")!
  const _component_oio_spin = _resolveComponent("oio-spin")!
  const _component_oio_empty_data = _resolveComponent("oio-empty-data")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-multi-select", [!_ctx.allowClear && 'hide-clear']])
  }, [
    (_ctx.innerReadonly && !_ctx.innerDisabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_a_select, {
            "max-tag-count": _ctx.maxTagCount,
            "label-in-value": "",
            mode: "multiple",
            value: _ctx.currentValue,
            options: _ctx.optionList
          }, null, 8, ["max-tag-count", "value", "options"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_a_select, {
            ref: "selectRef",
            mode: "multiple",
            class: "oio-select multi-select",
            "show-search": "",
            "label-in-value": "",
            "max-tag-count": _ctx.maxTagCount,
            allowClear: _ctx.allowClear,
            disabled: _ctx.innerDisabled,
            value: _ctx.currentValue,
            "filter-option": false,
            "default-active-first-option": false,
            options: _ctx.optionList,
            placeholder: _ctx.innerReadonly || _ctx.innerDisabled ? '' : _ctx.placeholder,
            "get-popup-container": _ctx.getTriggerContainer,
            dropdownClassName: _ctx.dropdownClassName,
            onChange: _ctx.innerChange,
            onSearch: _ctx.search,
            onBlur: _ctx.blur,
            onFocus: _ctx.focus,
            onPopupScroll: _ctx.slipSelect,
            onDropdownVisibleChange: _ctx.dropdownVisibleChange
          }, {
            dropdownRender: _withCtx(({ menuNode: menu }) => [
              _createVNode(_component_v_nodes, { vnodes: menu }, null, 8, ["vnodes"]),
              _createElementVNode("div", _hoisted_3, [
                (_ctx.loadMoreLoading)
                  ? (_openBlock(), _createBlock(_component_oio_spin, {
                      key: 0,
                      size: "small",
                      loading: ""
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            notFoundContent: _withCtx(() => [
              (!_ctx.loadMoreLoading)
                ? (_openBlock(), _createBlock(_component_oio_empty_data, { key: 0 }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["max-tag-count", "allowClear", "disabled", "value", "options", "placeholder", "get-popup-container", "dropdownClassName", "onChange", "onSearch", "onBlur", "onFocus", "onPopupScroll", "onDropdownVisibleChange"])
        ]))
  ], 2))
}